import { Button, ButtonsGroup } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useSegment } from '../../../../../../../../../../hooks'
import { useSyncErrorTopBar } from '../../../../contexts/syncErrorTopBarContext'

export const ModalFooter = (): ReactElement => {
  const { t } = useTranslation()
  const { track } = useSegment()
  const { closeUnrecognizedVatRatesModal, openSkipAndCompleteSyncModal, redirectAndOpenCreateVatRateModal } =
    useSyncErrorTopBar()

  const handleCreateVatRatesButtonClick = useCallback(() => {
    track('xxx-sales-HistoricalSync-Resolution Option Selected', {
      selectedOption: 'Create VAT Rates',
    })
    closeUnrecognizedVatRatesModal()
    redirectAndOpenCreateVatRateModal()
  }, [closeUnrecognizedVatRatesModal, redirectAndOpenCreateVatRateModal, track])

  const handleSkipAndCompleteButtonClick = useCallback(() => {
    track('xxx-sales-HistoricalSync-Resolution Option Selected', {
      selectedOption: 'Skip and Complete',
    })
    closeUnrecognizedVatRatesModal()
    openSkipAndCompleteSyncModal()
  }, [closeUnrecognizedVatRatesModal, openSkipAndCompleteSyncModal, track])

  return (
    <ButtonsGroup>
      <Button onClick={handleCreateVatRatesButtonClick} variant="outlined">
        {t('external_invoices_sync_unrecognized_vat_rates_modal.create_rates_button')}
      </Button>
      <Button onClick={handleSkipAndCompleteButtonClick}>
        {t('external_invoices_sync_unrecognized_vat_rates_modal.skip_and_complete_button')}
      </Button>
    </ButtonsGroup>
  )
}
